<div
    [appEventContextMenu]="event()"
    [appEventContextMenuDisabled]="!withContextMenu()"
    role="button"
    class="rounded-md px-2 py-1 h-10 flex gap-2 items-center text-sm whitespace-nowrap select-none border hover:cursor-pointer focus-visible:outline-dashed focus-visible:outline-1"
    [ngClass]="[
      ['text-background', !!selected()],
      ['border-transparent', isSettled()]
    ]"
    [style.outline-color]="eventColor()"
    [style.border-color]="borderColor()"
    [style.background-color]="selected() ? eventColor() : bgColor()"
    [style.--hover-bg-color]="selected() ? eventColor() : hoverColor()"
    [attr.tabindex]="tabindex() ?? -1"
    [attr.aria-label]="'Event: ' + event().title + ' at ' + (event().startTime | dateFormat: 'timeShort')"
  >
    @if (event().pinned) {
      <stch-pinned-icon size="s" [active]="true"/>
    }
    @if (event().flagged) {
      <app-flagged-icon size="s"/>
    }
    @if (event().snoozed) {
      <app-snoozed-icon size="s" [date]="event().snoozed"/>
    }
    @if (event().followed) {
      <app-followed-icon size="s" [date]="event().followed"/>
    }
    <div
      class="min-w-4 min-h-4 rounded-[4px]"
      [class.bg-background]="selected()"
      [style.background-color]="selected() ? undefined : swatchColor()"
    ></div>
    @if (!event().allDay) {
      <span [class.text-subdued]="!selected()">{{ event().startTime | dateFormat: 'timeShort' }}</span>
    }
    <span
      class="font-medium min-w-0 overflow-x-hidden text-ellipsis"
      [class.text-gray-950]="!selected() && !isPast()"
      [class.text-gray-600]="!selected() && isPast()"
    >
      @if (statusPrefix()) {
        <span>{{ statusPrefix() }}&ngsp;</span>
      }
      {{ event().title ? event().title : '(No title)' }}
    </span>
    <app-row-status-mark [row]="event()" />
  </div>
